import Icon from 'components/AppIcon';

const BoardFilters = ({ filters, onFiltersChange, onRefresh }) => {
  const handleSearchChange = (e) => {
    onFiltersChange({ ...filters, search: e.target.value });
  };

  const clearFilters = () => {
    onFiltersChange({
      search: '',
    });
  };

  const hasActiveFilters = filters.search !== '';

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-5 shadow-sm space-y-4 mb-6">
      <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
        {/* Search Bar */}
        <div className="relative flex-1 w-full">
          <Icon
            name="Search"
            size={18}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
          />
          <input
            type="text"
            value={filters.search}
            onChange={handleSearchChange}
            placeholder="Search by name or Employee ID..."
            className="w-full pl-11 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all placeholder-gray-400 text-sm font-medium"
          />
        </div>

        {/* Filters and Actions */}
        <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto">
          {/* Refresh Button */}
          <button
            onClick={onRefresh}
            className="p-2 bg-gray-50 hover:bg-gray-100 text-gray-600 rounded-xl border border-gray-200 transition-colors"
            title="Refresh Board"
          >
            <Icon name="RefreshCw" size={18} />
          </button>

          {/* Clear Filters */}
          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-xl transition-colors"
            >
              Clear Filters
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BoardFilters;
